import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IUpdateCreatorFitMasterPromptPayload } from "../types";
import { readApiError } from "./readApiError";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.GET],
  skipInvalidation: false,
};

export function useUpdateDraftVetMasterPrompt(config?: {
  onSuccess?: () => void;
}) {
  const updateDraftVetMasterPrompt = useCallback(
    (payload: IUpdateCreatorFitMasterPromptPayload) =>
      AiWorkspaceService.updateDraftVetMasterPrompt(payload).catch(async (err) => {
        ToastService.error(
          await readApiError(err, "Failed to update master prompt")
        );
        throw err;
      }),
    []
  );

  const { mutate: update, isLoading: isUpdating } =
    useMutation<IUpdateCreatorFitMasterPromptPayload>({
      mutationFn: updateDraftVetMasterPrompt,
      options: QUERY_OPTIONS,
      onSuccess: config?.onSuccess,
    });

  return { update, isUpdating };
}
